import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Slideshow.css';

const Slideshow = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  };

  return (
    <section className="slideshow">
      <div className="slideshow-container">
        <Slider {...settings}>
          <div className="slide">
            <img src="slides/slide1.jpeg" alt="Legal Consultation" />
          </div>
          <div className="slide">
            <img src="slides/slide2.jpeg" alt="Team Meeting" />
          </div>
        </Slider>
      </div>
      <div className="mission-section">
        <h2>Our Commitment</h2>
        <div className="values-grid">
          <div className="value-card">
            <h3>Clients</h3>
            <p>We keep your needs first while working closely with you.</p>
          </div>
          <div className="value-card">
            <h3>Availability</h3>
            <p>We ensure quick response and prompt updates.</p>
          </div>
          <div className="value-card">
            <h3>Value</h3>
            <p>High quality services and long term experience.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slideshow;